import React, { Fragment } from 'react';
import filmDetailUrl from '../../../../../shared/helpers/filmDetailUrl';

const Overlay = ({ film }) => {
  const { id, title, rated, deal, hasTrailer } = film;
  const detailUrl = filmDetailUrl(film);

  const renderRating = () => {
    if (rated) {
      return (
        <ul className="movie-attributes">
          <li>
            <i className="icon-fsk"></i> FSK: {rated}
          </li>
        </ul>
      );
    }
  };

  const renderButtons = () => {
    if (deal) {
      return (
        <a
          href={detailUrl}
          className="btn btn__primary inverse movie-poster--tickets"
        >
          Mehr Erfahren
        </a>
      );
    }

    return (
      <Fragment>
        {hasTrailer && (
          <a
            href={null}
            onClick={(e) => {
              e.preventDefault();
              window.TrailerService.showTrailer(id, title);
            }}
            className="play-toggle"
            style={{ cursor: 'pointer' }}
          >
            <span className="play-toggle--circle">
              <i className="icon-play"></i>
            </span>
          </a>
        )}
        <a
          href={detailUrl}
          className="btn btn__primary inverse movie-poster--tickets"
        >
          Tickets
        </a>
      </Fragment>
    );
  };

  return (
    <div className="movie-poster--details">
      <h4 className="movie-poster--title">
        <a className="movie-poster--link" href={detailUrl}>
          {title}
        </a>
      </h4>
      {renderRating()}
      {renderButtons()}
    </div>
  );
};

export default Overlay;
